import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button } from '@beef/ui-kit';

import TakeAwayDropDown from 'components/TakeawayControlsLayout/components/TakeAwayDropdown/index';

import { PointsInfo, PointsInfoList } from '../PointsInfo';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class PointsListView extends React.PureComponent {
  componentWillUnmount() {
    const { showMorePoints } = this.props;
    showMorePoints(null);
  }

  render() {
    const {
      children,
      points,
      className,
      isMobile,
      isTablet,
      openPickupBuy,
      goBasket,
      viewState,
      pointsCount,
      pointsToRenderLength,
      showMorePoints,
      hidePoints,
      messageClass,
    } = this.props;
    const morePointsToShow =
      pointsCount - pointsToRenderLength >= 15 ? 15 : pointsCount - pointsToRenderLength;

    return (
      <div className={cx('component', className)}>
        {isTablet && <TakeAwayDropDown />}
        {children}
        {points ?
          <PointsInfoList className={cx({ mobile: isMobile })}>
            {points
              ?.slice(0, pointsToRenderLength)
              ?.map(
                ({
                  movement_id: movementId,
                  movement_time: movementTime,
                  equipment_id: equipmentId,
                  movement_date: movementDate,
                  point_type: pointType,
                  dop_info: dopInfo,
                  onlyCardThankYouTitle,
                  availableDate,
                  address,
                  opening,
                  subway,
                  pointCode,
                  name,
                  priceTitle,
                  partner,
                  price,
                  onlyCard,
                  onlyCardTitle,
                  priceSubTitle,
                  paymentMethods,
                  delivery_days: deliveryDays,
                  minDate,
                }) => (
                  <PointsInfo
                    {...{
                      address,
                      opening,
                      subway,
                      onlyCard,
                      name,
                      partner,
                      price,
                      pointType,
                      priceTitle,
                      priceSubTitle,
                      onlyCardTitle,
                      movementId,
                      movementDate,
                      equipmentId,
                      availableDate,
                      paymentMethods,
                      deliveryDays,
                      minDate,
                      dopInfo,
                      isMobile,
                    }}
                    isCompact={isMobile}
                    isTablet={isTablet}
                    key={address}
                    onClick={() => {
                      openPickupBuy(
                        true,
                        {
                          address,
                          pointCode,
                          opening,
                          name,
                          price,
                          partner,
                          onlyCard,
                          onlyCardTitle,
                          onlyCardThankYouTitle,
                          point_type: pointType,
                          movement_id: movementId,
                          movement_time: movementTime,
                          movement_date: movementDate,
                          equipment_id: equipmentId,
                          paymentMethods,
                          deliveryDays,
                          minDate,
                        },
                        viewState,
                        isMobile,
                        isTablet,
                      );
                    }}
                  >
                    {name}
                  </PointsInfo>
                ),
              )}
          </PointsInfoList>
        : null}
        {pointsCount > 0 && pointsCount - pointsToRenderLength > 0 ?
          <Button
            onClick={() => {
              showMorePoints(morePointsToShow);
            }}
            type="button"
            fullWidth
            variant="tertiary"
          >
            {`Показать ещё ${morePointsToShow}`}
          </Button>
        : null}
        {morePointsToShow === 0 && pointsCount > 5 ?
          <Button
            onClick={() => {
              hidePoints();
            }}
            type="button"
            fullWidth
            variant="tertiary"
          >
            Скрыть
          </Button>
        : null}
        {/* TODO: расхардкодить */}
        {!isMobile && (
          <div className={cx('message', messageClass, isMobile ? 'messageMobile' : '')}>
            Если вы не нашли подходящий вам магазин,&nbsp;
            <span className={cx('action')} onClick={goBasket} role="button" tabIndex={0}>
              положите товар в корзину,
            </span>
            &nbsp;и мы доставим его с курьером
          </div>
        )}
      </div>
    );
  }
}

PointsListView.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.string,
      opening: PropTypes.string,
      onlyCard: PropTypes.bool,
      onlyCardThankYouTitle: PropTypes.string,
      dop_info: PropTypes.string,
      point_type: PropTypes.any,
      partner: PropTypes.shape({
        slug: PropTypes.string,
        id: PropTypes.number,
      }),
      priceTitle: PropTypes.string,
      priceSubTitle: PropTypes.string,
      availableDate: PropTypes.string,
      subway: PropTypes.shape({
        header: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  ),
  pointsCount: PropTypes.number,
  pointsToRenderLength: PropTypes.number,
  showMorePoints: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  openPickupBuy: PropTypes.func,
  goBasket: PropTypes.func,
  viewState: PropTypes.string,
  hidePoints: PropTypes.func,
  messageClass: PropTypes.string,
};
